import { render, staticRenderFns } from "./specifics.vue?vue&type=template&id=7ee4ea39&scoped=true&"
import script from "./specifics.vue?vue&type=script&lang=js&"
export * from "./specifics.vue?vue&type=script&lang=js&"
import style0 from "./specifics.vue?vue&type=style&index=0&id=7ee4ea39&scoped=true&lang=less&"
import style1 from "./specifics.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee4ea39",
  null
  
)

export default component.exports